// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__c8yHq","left":"StickyBox_left__2mChF","right":"StickyBox_right__37M7S"};